/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox, Col, notification, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHttp } from '../../../../../../hooks/http';
import { URL_API } from '../../../../../../utils';

const PromotionPayment = ({ data, handleChange }) => {

    const [checkedList, setCheckedList] = useState([]);
    const [plainOptions, setPlainOptions] = useState([]);
    const [indeterminate, setIndeterminate] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const [loadingMasterPayment, masterPayment, errorMasterPayment] = useHttp({
        method: 'GET',
        url: `${URL_API}/system/master/payin_type`,
        token: true
    }, []);

    if (errorMasterPayment) {
        notification.error({
            message: 'error',
            description: errorMasterPayment,
        });
    }

    useEffect(() => {
        if (data.payment.length > 0) {
            let length = data.payment.length
            setIndeterminate(length > 0 && length < plainOptions.length)
            setCheckAll(length === plainOptions.length)
            setCheckedList(data.payment)
        }
    }, [data, plainOptions])

    useEffect(() => {
        let list = [];
        if (!loadingMasterPayment) {
            masterPayment && masterPayment.data.forEach(item => {
                const { code } = item;
                if (code) {
                    list.push({ label: item.name, value: item.code })
                }
            });
            setPlainOptions(list);
        }
    }, [masterPayment])

    const onChange = e => {
        setCheckedList(e)
        setIndeterminate(e.length > 0 && e.length < plainOptions.length)
        setCheckAll(e.length === plainOptions.length)

        handleChange({
            target: {
                name: "payment",
                value: e
            }
        });
    }
    const onCheckAllChange = e => {
        setCheckedList(e.target.checked ? plainOptions.map(n => n.value) : [])
        setIndeterminate(false)
        setCheckAll(e.target.checked)

        handleChange({
            target: {
                name: "payment",
                value: e.target.checked ? plainOptions.map(n => n.value) : []
            }
        });
    };
    return (
        <>
            <Row >
                <Col md={12} style={{ columnCount: 2, width: '100%' }}>
                    <Checkbox
                        indeterminate={indeterminate}
                        onChange={onCheckAllChange}
                        checked={checkAll}
                    >
                        ทุกประเภท
                    </Checkbox>
                    <Checkbox.Group
                        style={{ display: 'grid', fontSize: '12px' }}
                        options={plainOptions}
                        value={checkedList}
                        onChange={onChange}
                    />
                </Col>
            </Row>
        </>
    )
}
export default PromotionPayment;
